import { ICardProps } from '@enter/core';
import React from 'react';
import * as S from './data-table-card.styles';

export const DataTableCard: React.FunctionComponent<ICardProps> = (props: ICardProps): React.ReactElement => {
    const { children } = props;
    return (
        <S.DataTableCard size="large" loading={false} empty={false}>
            {children}
        </S.DataTableCard>
    );
};
